module.exports = __webpack_public_path__ + "static/img/动态危险区域闯入识别.4259465f.png";